import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Drawer } from 'antd'

import { server, stringifyDate, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'

const StockTake = ({ store }) => {
    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const [{ loading, error, data }] = usePet('stockTake', { id }, { notify: true })

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">Stock Take #{ Number(data?.code) < 1000 ? ('00000' + data?.code).slice(-4) : data?.code }</p>
            <p className="text-gray-500 text-xs italic mb-2">Stock take sheet uploaded by { data?.uploadedBy?.name } on { stringifyDate(data?.uploadedOn) }</p>
            <div className='mb-4'>Status: <span className={ data?.processCompletedOn ? 'text-green-500' : 'text-yellow-500' }>{  data?.processCompletedOn ? `Upload Completed on ${stringifyDate(data.processCompletedOn)}` : 'Pending'  }</span></div>
            <Receive
                loading={loading}
                error={ error }
                progress>
                <div className="p-0">
                    <div className="w-full md:mb-0">
                        <label className="block tracking-wide text-gray-500 font-semibold mb-0" htmlFor="grid-name">
                            Store
                        </label>
                        <p className="font-semibold text-lg mb-3">{ data?.store?.name }</p>
                    </div>
                    <div className="w-full md:mb-0">
                        <label className="block tracking-wide text-gray-500 font-semibold mb-0" htmlFor="grid-name">
                            Stock Take Date
                        </label>
                        <p className="font-semibold text-lg mb-3">{ stringifyDate(data?.date) }</p>
                    </div>
                    <div className="w-full md:mb-0">
                        <label className="block tracking-wide text-gray-500 font-semibold mb-0" htmlFor="grid-name">
                            Timeline
                        </label>
                        <p className="font-semibold text-lg mb-3">From { stringifyDate(data?.startedOn) } To { stringifyDate(data?.completedOn) }</p>
                    </div>
                    <div className="w-full md:mb-0">
                        <label className="block tracking-wide text-gray-500 font-semibold mb-0" htmlFor="grid-name">
                            Description
                        </label>
                        <p className="font-semibold text-lg mb-3">{ data?.desc }</p>
                    </div>
                    <div className="w-full md:mb-0">
                        <label className="block tracking-wide text-gray-500 font-semibold mb-0" htmlFor="grid-name">
                            Uploaded By
                        </label>
                        <p className="font-semibold text-lg mb-3">{ data?.uploadedBy?.name }</p>
                    </div>
                    <div className="w-full md:mb-0">
                        <label className="block tracking-wide text-gray-500 font-semibold mb-0" htmlFor="grid-name">
                            Stock Take Sheet
                        </label>
                        <p className="font-semibold text-lg mb-3">Click <a href={ `${server}/uploads/stock_take_list/${ data?.sheet }` } target="_blank" rel="noreferrer">here</a> to view</p>
                    </div>
                </div>
            </Receive>
        </Drawer>
    )
}

export default StockTake